import {useLocation, usePrevious} from '@/hooks';
import {useEffect} from 'react';
import {usePurchaseContext} from './PurchaseProvider';
import {useRouter} from 'next/navigation';

export const PurchaseCompletedCleanup = () => {
	const {state: purchaseState} = usePurchaseContext();
	const prevPurchaseState = usePrevious(purchaseState);
	const location = useLocation();
	const router = useRouter();

	useEffect(() => {
		// user was in the purchase flow but cancelled or completed
		const shouldReset =
			Boolean(prevPurchaseState) &&
			prevPurchaseState !== 'inactive' &&
			purchaseState === 'inactive' &&
			location.searchParams.has('purchaseIntentId');

		if (shouldReset) {
			location.url.searchParams.delete('purchaseIntentId');
			router.replace(location.url.toString());
		}
	}, [purchaseState, prevPurchaseState, location.searchParams]);

	return null;
};
